var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 13.9999C2.6665 13.6317 2.96498 13.3333 3.33317 13.3333H12.6665C13.0347 13.3333 13.3332 13.6317 13.3332 13.9999C13.3332 14.3681 13.0347 14.6666 12.6665 14.6666H3.33317C2.96498 14.6666 2.6665 14.3681 2.6665 13.9999Z",
    fill: "#6B92FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.27422 2.11625C9.31562 1.07485 11.0041 1.07486 12.0455 2.11625L12.5504 2.62116C13.5918 3.66256 13.5918 5.351 12.5504 6.3924L7.94629 10.9964C7.76134 11.1814 7.52607 11.3079 7.26977 11.3601L4.26738 11.972C3.33102 12.1629 2.50379 11.3357 2.69462 10.3993L3.30649 7.39684C3.35872 7.14053 3.4852 6.90525 3.67016 6.72028L8.27422 2.11625ZM11.1026 3.05906C10.5819 2.53836 9.73773 2.53836 9.21703 3.05906L8.9426 3.33349L11.3331 5.72401L11.6075 5.44959C12.1282 4.92889 12.1282 4.08467 11.6075 3.56397L11.1026 3.05906ZM5.60926 6.66681L7.99979 4.2763L10.3903 6.66682L7.99978 9.05734L5.60926 6.66681ZM4.66644 7.60962L4.61297 7.66309L4.0011 10.6656L7.00349 10.0536L7.05697 10.0001L4.66644 7.60962Z",
    fill: "#6B92FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.47a8ad2f.svg";
export { ForwardRef as ReactComponent };